import React, { useEffect } from 'react';

const toastStyles = {
  success: {
    bgClass: 'bg-success text-white',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" className="bi bi-check-circle-fill me-2" viewBox="0 0 16 16">
        <path d="M16 8a8 8 0 1 1-16 0A8 8 0 0 1 16 8zM6.97 11.03a.75.75 0 0 0 1.07 0l4.243-4.242a.75.75 0 1 0-1.06-1.06L7.5 9.439 5.823 7.763a.75.75 0 0 0-1.06 1.06l2.207 2.207z" />
      </svg>
    ),
  },
  error: {
    bgClass: 'bg-danger text-white',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" className="bi bi-x-circle-fill me-2" viewBox="0 0 16 16">
        <path d="M16 8a8 8 0 1 1-16 0A8 8 0 0 1 16 8zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
      </svg>
    ),
  },
  info: {
    bgClass: 'bg-info text-white',
    icon: (
      <svg class="me-2 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 11h2v5m-2 0h4m-2.592-8.5h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
      </svg>

    ),
  },
  warning: {
    bgClass: 'bg-warning text-dark',
    icon: (
      <svg className="me-2 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
      </svg>
    ),
  },
};

const ToastNotification = ({ message, show, onClose, type = 'success' }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(onClose, 3000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  if (!show) return null;

  const { bgClass, icon } = toastStyles[type] || toastStyles.success;

  return (
    <div
      className="toast-container position-fixed bottom-0 end-0 p-3"
      style={{ zIndex: 9999 }}
    >
      <div className={`toast p-4 align-items-center show fade ${bgClass}`} role="alert" aria-live="assertive" aria-atomic="true">
        <div className="d-flex">
          <div className="toast-body d-flex align-items-center">
            {icon}
            <span>{message}</span>
          </div>
          <button
            type="button"
            className="btn-close btn-close-white me-2 m-auto"
            aria-label="Close"
            onClick={onClose}
          ></button>
        </div>
      </div>
    </div>
  );
};

export default ToastNotification;